import { FETCH_GLOBAL_INFO } from './user-info';

export default (state = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_GLOBAL_INFO:
      return payload._duccRoutes || [];
    // return payload.a;
    default:
      return state;
  }
};
